// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__vcztJ","alertIcon":"ConfirmModal_alertIcon__1Z5TK"};